import { BUYING_GUIDES } from './editorial-content';
import { EDITORIAL_ARTICLES } from './editorial-articles';
import { NEW_BUYING_GUIDES, NEW_HOME_ARTICLES } from './journal-additions';

export const JOURNAL_BUYING_GUIDES = [...NEW_BUYING_GUIDES, ...BUYING_GUIDES];
export const JOURNAL_ARTICLES = [...NEW_HOME_ARTICLES, ...EDITORIAL_ARTICLES];

// One assessment per distinct search category, shared wherever that category is recommended.
const categories = new Map<string, { name: string; why: string; search: string; parentSlug: string }>();
for (const guide of JOURNAL_BUYING_GUIDES) {
  for (const product of guide.productCategories) {
    if (!categories.has(product.search)) categories.set(product.search, { ...product, parentSlug: guide.slug });
  }
}
export const PRODUCT_ASSESSMENTS = [...categories.values()].map(product => {
  const parent = JOURNAL_BUYING_GUIDES.find(guide => guide.slug === product.parentSlug);
  return {
    slug: `product-review-${product.search.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '')}`,
    category: 'Product assessments', title: `${product.name}: worth buying?`,
    description: product.why, updated: '31 October 2026', readTime: '3 min read',
    intro: `This is a category assessment of ${product.name.toLowerCase()}, not a hands-on review of a named model. ${product.why}`,
    sections: [
      { heading: 'Where it fits', paragraphs: [parent?.intro ?? product.why] },
      { heading: 'What to verify before buying', paragraphs: [product.why], bullets: ['Match the exact product to your surface or machine.', 'Check care instructions, included parts and replacement availability.', 'Compare current seller terms and total cost, not just the headline price.'] },
      { heading: 'Limitations and alternatives', paragraphs: [parent?.verdict ?? 'Check suitability before buying.'], bullets: ['No named model has been personally tested for this assessment.', 'A category listing cannot verify an individual product’s performance.', 'Avoid buying specialist equipment for unsafe or unfamiliar work.'] },
      { heading: 'Our decision', paragraphs: [`Consider this category only when it meets the checks above. ${product.why} If you cannot establish compatibility, keep looking or ask a suitable professional.`] }
    ],
    note: 'Editorial category assessment. No test scores, personal-use claims or live prices. Verify specifications with the product manufacturer.',
    productSearch: product.search, parentSlug: product.parentSlug
  };
});
export function assessmentFor(search: string) { return PRODUCT_ASSESSMENTS.find(item => item.productSearch === search); }
export const JOURNAL_COLLECTION = [...JOURNAL_ARTICLES, ...JOURNAL_BUYING_GUIDES.map(guide => ({ ...guide, category: 'Buying guides' })), ...PRODUCT_ASSESSMENTS];

export function filterJournal(search: string, topic: string) {
  const query = search.trim().toLowerCase();
  return JOURNAL_COLLECTION.filter(item => (topic === 'All' || item.category === topic) && `${item.title} ${item.description} ${item.category}`.toLowerCase().includes(query));
}